"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var VolumeDiscountView = function (_a) {
    var disocunt = _a.disocunt;
    var _b = (0, CalculatorContextInterface_1.useCalculatorContext)(), calculatedAmounted = _b.calculatedAmounted, game = _b.game;
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    return (react_1.default.createElement("div", { className: "__wrap-item __bg-grey" },
        react_1.default.createElement("span", { className: "__item-info-checkout" }, t("calculator.view.volume_discount")),
        react_1.default.createElement("span", { className: "__item-value-checkout" },
            disocunt ? disocunt : 0,
            " %")));
};
exports.default = VolumeDiscountView;
